import React from 'react'
import classNames from 'classnames'

import { DepthKeys, useLanguages } from '@/hooks'
import { Link } from '@/i18n'

import { IBreadcrumbsProps } from './types'
import { joinArray } from '@/utils'

export const Breadcrumbs = <T extends DepthKeys>({
  links,
}: IBreadcrumbsProps<T>) => {
  const { t } = useLanguages()
  return (
    <div className="breadcrumbs">
      <div className="row">
        <div className="column small-12">
          <ul className="flex-container flex-row-wrap">
            {links.map((link, idx) => (
              <li key={idx}>
                <Link
                  href={link.path}
                  className={classNames('arrow--right', link.className)}
                >
                  {joinArray(' ', t(link.title), ' ')}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  )
}
